export const GOOGLE_PLACES_KEY = 'AIzaSyDX7WbIqiOMqqKrEiR4bpnYCx4wRrm76Sc';
